<div *ngIf="aberto" class="modal-v2-fundo z-[450] p-4">
  <div role="dialog" aria-modal="true" aria-labelledby="tituloEspecie"
       class="modal-v2" style="max-width: 460px; max-height: 92vh">

    <div class="modal-v2-topo">
      <div class="flex-1 min-w-0">
        <p class="modal-v2-eyebrow">Pagamento em espécie</p>
        <h3 id="tituloEspecie" class="modal-v2-titulo">{{ recibo ? 'Pagamento registrado' : 'Receber em dinheiro' }}</h3>
        <p *ngIf="!recibo" class="modal-v2-sub">O valor entra no seu caixa e fica como crédito do paciente para quitar a conta.</p>
      </div>
      <button type="button" (click)="fecharModal()" [disabled]="isRegistrando" title="Fechar" class="modal-v2-fechar">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
             stroke-width="2" stroke="currentColor" class="size-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Sucesso -->
    <div *ngIf="recibo" class="px-7 pb-6 flex flex-col items-center text-center gap-1">
      <span class="grid place-items-center rounded-full mb-2"
            style="width: 52px; height: 52px; background: rgba(0,172,112,.12); color: var(--brand-secondary)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.2" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5"/>
        </svg>
      </span>
      <p style="font-size: 26px; font-weight: 800; color: var(--tx); font-variant-numeric: tabular-nums">{{ recibo.valor | brl }}</p>
      <p style="font-size: 13px; color: var(--tx-2)">Recibo nº <strong style="color: var(--tx)">{{ recibo.nrRecibo }}</strong></p>

      <div *ngIf="precisaSangria" class="aviso-v2 ambar mt-4 text-left w-full">
        O caixa passou de <strong>R$ 1.000</strong> ({{ saldoCaixaProjetado | brl }}). Faça uma <strong>sangria</strong> em seguida.
      </div>
      <div *ngIf="erro" class="aviso-v2 vermelho mt-3 text-left w-full">{{ erro }}</div>
    </div>

    <!-- Formulário -->
    <div *ngIf="!recibo" class="px-7 pb-6 overflow-y-auto flex flex-col gap-4" style="min-height: 0">

      <div class="rounded-2xl px-4 py-4 text-center" style="background: var(--flua-rodape); border: 1px solid #EFE9DD">
        <p class="form-v2-secao">Valor recebido</p>
        <div class="flex items-baseline justify-center gap-1 mt-1">
          <span style="font-size: 18px; font-weight: 700; color: var(--tx-2)">R$</span>
          <input type="number" step="0.01" min="0" [(ngModel)]="valor" (focus)="$any($event.target).select()"
                 class="text-center bg-transparent outline-none"
                 style="width: 170px; font-size: 30px; font-weight: 800; color: var(--tx); border-bottom: 2px solid var(--flua-borda); font-variant-numeric: tabular-nums" />
        </div>
        <p style="font-size: 12px; color: var(--tx-2); margin-top: 6px">Saldo da conta: <strong>{{ valorConta | brl }}</strong></p>
      </div>

      <div *ngIf="troco > 0" class="rounded-xl px-4 py-3" style="background: rgba(0,172,112,.08); border: 1px solid rgba(0,172,112,.28)">
        <div class="flex justify-between" style="font-size: 13px; color: var(--tx-2)">
          <span>Valor da conta</span><strong>{{ valorConta | brl }}</strong>
        </div>
        <div class="flex justify-between items-baseline mt-1 pt-1" style="border-top: 1px dashed rgba(0,172,112,.35)">
          <span style="font-size: 13px; font-weight: 700; color: #0E7A53">Troco para o paciente</span>
          <strong style="font-size: 18px; color: #0E7A53">{{ troco | brl }}</strong>
        </div>
      </div>

      <div *ngIf="precisaSangria" class="aviso-v2 ambar">
        Depois deste recebimento o caixa fica em <strong>{{ saldoCaixaProjetado | brl }}</strong>, acima de R$ 1.000.
        Faça uma <strong>sangria</strong> em seguida.
      </div>

      <label>
        <span class="rotulo-v2">Caixa</span>
        <div *ngIf="isCarregandoCaixas" style="font-size: 12px; color: var(--tx-2)">Carregando caixas...</div>
        <div *ngIf="!isCarregandoCaixas && caixas.length === 0" class="aviso-v2 ambar">
          Você não tem caixa nesta unidade.
        </div>
        <select *ngIf="!isCarregandoCaixas && caixas.length > 0" [(ngModel)]="caixaSelecionada" class="campo-v2">
          <option *ngFor="let c of caixas" [ngValue]="c">{{ c.name }} — {{ c.establishmentName }}</option>
        </select>
      </label>

      <div *ngIf="caixaSelecionada && caixaSelecionada.balanceForToday"
           class="flex items-center gap-2" style="font-size: 12px; color: #0E7A53">
        <span class="w-1.5 h-1.5 rounded-full" style="background: var(--brand-secondary)"></span>
        Saldo de hoje aberto (seq {{ caixaSelecionada.balanceSequence }})
      </div>

      <div *ngIf="caixaSelecionada && !caixaSelecionada.balanceForToday" class="aviso-v2 ambar flex items-center justify-between gap-3">
        <span>Este caixa ainda não tem saldo aberto hoje.</span>
        <button type="button" (click)="abrirSaldoHoje()" [disabled]="isAbrindoSaldo"
                class="chip-v2 ativo shrink-0">
          {{ isAbrindoSaldo ? 'Abrindo...' : 'Abrir saldo de hoje' }}
        </button>
      </div>

      <div *ngIf="saldoAbertoFeedback" style="font-size: 12px; color: #1D4F91">{{ saldoAbertoFeedback }}</div>

      <label>
        <span class="rotulo-v2">Observação <span style="font-weight: 400; color: var(--tx-2)">(opcional)</span></span>
        <input type="text" maxlength="200" [(ngModel)]="observacao"
               placeholder="Ex.: pagamento da consulta" class="campo-v2" />
      </label>

      <div *ngIf="erro" class="aviso-v2 vermelho">{{ erro }}</div>
    </div>

    <div class="flex items-center justify-end gap-2 px-7 py-4"
         style="border-top: 1px solid #EFE9DD; background-color: var(--flua-rodape); border-radius: 0 0 18px 18px; flex-shrink: 0">
      <ng-container *ngIf="!recibo">
        <button type="button" (click)="fecharModal()" [disabled]="isRegistrando"
                class="px-6 bg-white"
                style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
          Cancelar
        </button>
        <button type="button" (click)="registrar()" [disabled]="!formValido || isRegistrando"
                class="px-6"
                style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700"
                [style.background-color]="!formValido || isRegistrando ? '#E5DFD4' : 'var(--brand-secondary)'"
                [style.color]="!formValido || isRegistrando ? '#8796A1' : '#fff'"
                [style.cursor]="!formValido || isRegistrando ? 'not-allowed' : 'pointer'">
          {{ isRegistrando ? 'Registrando...' : 'Registrar pagamento' }}
        </button>
      </ng-container>
      <ng-container *ngIf="recibo">
        <button type="button" (click)="imprimirRecibo()" [disabled]="isImprimindo"
                class="px-6 bg-white"
                style="height: 44px; border-radius: 10px; border: 1px solid var(--flua-borda); font-size: 14px; font-weight: 600; color: var(--tx-2)">
          {{ isImprimindo ? 'Carregando...' : 'Imprimir recibo' }}
        </button>
        <button type="button" (click)="fecharModal()"
                class="px-6 text-white"
                style="height: 44px; border-radius: 10px; font-size: 14px; font-weight: 700; background: var(--brand-primary)">
          Concluir
        </button>
      </ng-container>
    </div>
  </div>
</div>
